import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";

const baseStyle = defineStyle({
  startColor: "blackAlpha.100",
  endColor: "blackAlpha.300",
})

export const Skeleton = defineStyleConfig({
  baseStyle,
});
